import kebabCase from 'lodash/kebabCase';

import { appService, envService } from 'services';

export const redirectToBusinessDomain = (businessName) => {
  const kebabBusinessName = kebabCase(businessName);

  if (kebabBusinessName) {
    let baseUrl;

    if (appService.isArrivaj()) {
      if (envService.isRunningInDev()) {
        baseUrl = `https://dev-${kebabBusinessName}.arrivaj.fr`;
      } else if (envService.isRunningInTest()) {
        baseUrl = `https://${kebabBusinessName}.dev-arrivaj.fr:5100`;
      } else if (envService.isRunningInStaging()) {
        baseUrl = `https://preprod-${kebabBusinessName}.arrivaj.fr`;
      } else if (envService.isRunningInProd()) {
        baseUrl = `https://${kebabBusinessName}.arrivaj.fr`;
      }
    }

    if (baseUrl) {
      const currentPath = window.location.pathname + window.location.search;
      window.location.assign(baseUrl + currentPath);
    }
  }
};
